var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.attributeData)?_c('div',[_c('text-attribute-'+_vm.attributeData.inputTypeKebab,{tag:"component",attrs:{"data":_vm.attributeData,"with-cols":true}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }